const isProd = process.env.NODE_ENV === 'production';

const noop = () => {};

const logger = {
  error: (...args) => {
    if (!isProd) console.error(...args);
  },
  warn: isProd ? noop : (...args) => console.warn(...args),
  info: isProd ? noop : (...args) => console.info(...args),
  log: isProd ? noop : (...args) => console.log(...args),
};

export { logger };
export default logger;
